import React from 'react';
import { View, type StyleProp, type ViewStyle } from 'react-native';
import { useTheme } from '../theme';
import Txt from './Txt';

type AvatarSize = 'xs' | 'sm' | 'md' | 'lg' | 'xl';

interface AvatarProps {
  /** Already-computed initials, e.g. "VK". */
  initials: string;
  size?: AvatarSize;
  background?: string;
  color?: string;
  style?: StyleProp<ViewStyle>;
}

const DIM: Record<AvatarSize, number> = { xs: 18, sm: 24, md: 32, lg: 44, xl: 56 };
const FS: Record<AvatarSize, number> = { xs: 9, sm: 10, md: 12, lg: 15, xl: 18 };

/** RN port of theme.css's .t-avatar — round initials chip, size + color overridable. */
export default function Avatar({ initials, size = 'md', background, color, style }: AvatarProps) {
  const t = useTheme();
  const d = DIM[size];
  return (
    <View
      style={[
        {
          width: d,
          height: d,
          borderRadius: d / 2,
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: background ?? t.colors.paper3,
          borderWidth: background ? 0 : 1,
          borderColor: t.colors.line,
        },
        style,
      ]}
    >
      <Txt weight="semibold" color={color ?? t.colors.ink2} style={{ fontSize: FS[size] }}>
        {initials.toUpperCase()}
      </Txt>
    </View>
  );
}
